import AppHttpClient from '../api-manager/api/http-client';
import { UploadImageResponseDto } from './dto/upload-image.response.dto';
import { HttpRequest, RequestType } from '../api-manager/api/http-request';

const uploadImageRequest = async (url: string, data: any) => {
  const request: HttpRequest = {
    url,
    method: RequestType.POST,
    data,
    headers: {
      'content-type': 'multipart/form-data',
    },
  };

  return await AppHttpClient.exec<any, UploadImageResponseDto>(
    request,
    UploadImageResponseDto
  );
};

export default uploadImageRequest;
